export default "__VITE_ASSET__9tJWC6l5__"